import { useListEntityApi } from '@/common/api/listEntityApi';
import type { Packaging } from 'shared/packages/domain/packaging';

export interface ListPackagingResponse {
  ok: true;
  packaging: Packaging[];
}

export function useListPackaging() {
  return useListEntityApi<ListPackagingResponse>({
    url: 'packaging',
    translate: (t) => t.packaging.actions.fetchMany,
    async processOk(response) {
      const json = await response.json() as Packaging[];

      json.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));

      return {
        ok: true,
        packaging: json,
      };
    },
  });
}
